import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './app/store';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import { DialogProvider, useDialog } from './context/DialogContext';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Colophon from './pages/Colophon';
import Impressum from './components/Impressum';
import Datenschutz from './components/Datenschutz';
import './App.css';

const AppContent: React.FC = () => {
  const { showImpressum, showDatenschutz, toggleImpressum, toggleDatenschutz } = useDialog();
  
  return (
    <>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/colophon" element={<Colophon />} />
          </Routes>
        </Layout>
      </Router>
      
      {/* Dialogs rendered at the root level */}
      <Impressum isOpen={showImpressum} onClose={toggleImpressum} />
      <Datenschutz isOpen={showDatenschutz} onClose={toggleDatenschutz} />
    </>
  );
};

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <LanguageProvider>
          <DialogProvider>
            <AppContent />
          </DialogProvider>
        </LanguageProvider>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
